"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeUtil = void 0;
const LangUtil_1 = require("../../base/cutil/LangUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const JsonUtil_1 = require("../../base/cutil/JsonUtil");
class HomeUtil {
    static async getObjectData(brainClient, attrIndexer) {
        const params = { attrIndexer };
        const res = await (0, LangUtil_1.tryPromise)(brainClient.graphql.objectSetRace(params));
        if (res.error) {
            console.log("res.error", res.error);
            throw "Get template failed";
        }
        if (!res.data?.data || (0, is_blank_1.default)(res.data.data)) {
            throw "data was empty";
        }
        const data = res.data.data;
        if (!data.getByAttrIndexer || (0, is_blank_1.default)(data.getByAttrIndexer)) {
            throw "getByAttrIndexer was empty";
        }
        const getByIndexerData = data.getByAttrIndexer.objectSet;
        if (!data.getByUUID || (0, is_blank_1.default)(data.getByUUID)) {
            throw "getByUUID was empty";
        }
        const getByUUidData = data.getByUUID.objectSet;
        const objectData = (0, is_blank_1.default)(getByIndexerData) ? getByUUidData : getByIndexerData;
        if ((0, is_blank_1.default)(objectData)) {
            console.log("objectSetRace result error");
            throw "Get template objectSet failed";
        }
        return objectData;
    }
    /**
     * 将api 返回的project 数据转为fot 正在使用的template
     * @param objectData
     * return {id: string, name?: string, uuid: string, attrIndexer: string,  ...attributes}
     * 注意： 除了明确的几个字段，还有attributes 里面的字段。
     */
    static transformProjectDataToTemplate(objectData) {
        const attributes = JsonUtil_1.JsonUtil.parse(objectData.attributes);
        return {
            ...attributes,
            id: objectData.id,
            name: objectData.attributesV2?.template_name,
            uuid: objectData.uuid,
            attrIndexer: objectData.attrIndexer,
            multiRoundChatData: objectData.attributesV2?.multiRoundChatData,
            updatedAt: objectData.updatedAt,
        };
    }
    /**
     * 获取attrIndexer
     * @param template
     */
    static getAttrIndexerByTemplateProject(template) {
        return template?.attrIndexer || template?.index || template?.uuid || "";
    }
}
exports.HomeUtil = HomeUtil;
